import React, { createContext, useState, useEffect } from 'react';
import { BuildExtremeBanner } from '../helpers/buildBanner';
import { node } from 'prop-types'

export const MasterBannerContext = createContext();

export const MasterContext = ({ children }) => {
  const [ master, setMaster ] = useState(null);
  const [ assets, setAssets ] = useState([]);
  const [ history, setHistory] = useState([]);
  const [ ctrl, setCtrl ] = useState(false);
  const [ undo, setUndo ] = useState(false);
  const [ listFonts, setListFonts ] = useState([]);

  function addHistory(banner) {
    if (!banner) return;
    try {
      var copyHistory = JSON.parse(JSON.stringify(history));
      copyHistory.push(banner);
      if (copyHistory.length > 5) copyHistory.shift();
    } catch {
      copyHistory = [banner];
    }
    setHistory(copyHistory);
  }

  useEffect(() => {
    try {
      const fetchBusinesses = () => {
        var banner = BuildExtremeBanner(master);
        if (!undo) {
          addHistory(banner);
        }
        setMaster(banner);
        setUndo(false);
        return true;
    }
      fetchBusinesses();
    } catch (error) { } 
  }, [master])

  useEffect(() => {
    try {
      if (history.length > 1 && undo) {
        var copyHistory = JSON.parse(JSON.stringify(history));
         copyHistory.pop();
         setHistory(copyHistory);
        setMaster(copyHistory[copyHistory.length !== 1 ? copyHistory.length -2 : copyHistory.length -1]);
      } else setUndo(false);
    } catch { }
  }, [undo])
  
	return (
    <MasterBannerContext.Provider
			value={{ master, setMaster, undo, setUndo, ctrl, setCtrl, history, setHistory, listFonts, setListFonts, assets, setAssets }}>
      {children}
    </MasterBannerContext.Provider>
	)
}

MasterContext.propTypes = {
  children: node.isRequired
}

